import type { BranchMiniEntity } from "@/features/branch/domain/entities/BranchMiniEntity"
import type { ServiceMiniEntity } from "@/features/service/domain/entities/ServiceMiniEntity"

export class BranchShowcaseFilterEntity {
  id!: number
  branch?: BranchMiniEntity
  service?: ServiceMiniEntity
  page?: number
  limit?: number
}

